export default __webpack_public_path__ + "static/series-d40981c7e650c2344958b29309b5e390.mp4";